export default "__VITE_ASSET__1f7904cd__"